import { render, staticRenderFns } from "./loginBut.vue?vue&type=template&id=647ae0f8"
import script from "./loginBut.vue?vue&type=script&lang=js"
export * from "./loginBut.vue?vue&type=script&lang=js"
import style0 from "./loginBut.vue?vue&type=style&index=0&id=647ae0f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports